import { GlobeIconWhite } from "./Icons";

export default function ChooseLocationWidget() {
  const handleRegionSelection = () => {
    const event = new CustomEvent("openRegionSelection");
    window.dispatchEvent(event);
  };
  return (
    <button
      type="button"
      onClick={handleRegionSelection}
      aria-label="Choose location"
      className="fixed z-20 bottom-16 right-16 640:bottom-20 640:right-20 1024:bottom-32 1024:right-32 p-12 rounded-xxxs bg-gray-900 border border-gray-700 media-hover:hover:bg-gray-800 duration-300"
    >
      <GlobeIconWhite />
    </button>
  );
}
